import { SupoInvoice } from '@supoui/shared/model/supo-invoice';
import { SupplierProfile } from '@supoui/shared/model/supplier-profile';
import { SupplierInvoice } from '@supoui/shared/model/supplier-invoice';
import { SupplierInvoiceItem } from '@supoui/shared/model/supplier-invoice-item';
import { SupplierInvoiceSaving } from '@supoui/shared/model/supplier-invoice-saving';
import { InvoiceDocumentTypeEnum } from '@supoui/shared/model/enumerations/invoice-document-type.enum';

export class SupoSeccaInvoiceMapper {
  private supplierProfiles: SupplierProfile[];

  constructor(supplierProfiles: SupplierProfile[]) {
    this.supplierProfiles = supplierProfiles;
  }

  public mapToSupplierInvoice(supoInvoice: SupoInvoice): SupplierInvoice {
    const supplierProfile = this.supplierProfiles.find(sp => sp.supplierProfileCode === supoInvoice.supplierProfileCode);
    const items = supoInvoice.items.map(supoItem => {
      const item = new SupplierInvoiceItem({
        id: supoItem.id ? supoItem.id : undefined,
        serviceOrderId: supoItem.serviceOrderId,
        serviceItemCode: supoItem.serviceItemCode,
        serviceItemName: supoItem.serviceItemName,
        quantity: supoItem.quantity,
        quantityUnit: supoItem.quantityUnit,
        paidAmount: supoItem.paidAmount,
        calculatedFromGross: supoItem.calculatedFromGross,
        savings: supoItem.savings.map(
          saving =>
            new SupplierInvoiceSaving({
              id: saving.id ? saving.id : undefined,
              reductionTypeCode: saving.reductionTypeCode,
              lineNumber: saving.lineNumber,
              amount: saving.amount,
              typedInField: saving.typedInField,
              gross: saving.gross
            })
        )
      });
      if (item.calculatedFromGross) {
        let amount = +item.paidAmount;
        item.savings
          .filter(s => s.gross)
          .sort((s1, s2) => s1.lineNumber - s2.lineNumber)
          .forEach(s => {
            amount += +s.amount;
            s.totalAmount = amount;
          });
      }
      return item;
    });

    const erpCreditor = supplierProfile?.getErpCreditors().find(erpCreditor => erpCreditor.erpId === +supoInvoice.creditorNumber);

    return new SupplierInvoice({
      id: supoInvoice.id ? supoInvoice.id : -1,
      invoiceNumber: supoInvoice.invoiceNumber,
      invoiceDate: supoInvoice.invoiceDate,
      invoiceAmountLocal: { currency: supoInvoice.invoiceCurrency, amount: supoInvoice.invoiceAmount, precision: 2 },
      creditorId: supoInvoice.creditorNumber,
      creditorName: erpCreditor?.name,
      invoiceDocument: supoInvoice.invoiceDocuments?.find(document => document.documentType === InvoiceDocumentTypeEnum.INVOICE) || null,
      travelAndExpensesDocuments:
        supoInvoice.invoiceDocuments?.filter(document => document.documentType === InvoiceDocumentTypeEnum.TRAVEL_AND_EXPENSES) || null,
      medicalTravelReportDocument:
        supoInvoice.invoiceDocuments?.find(document => document.documentType === InvoiceDocumentTypeEnum.MEDICAL_TRAVEL_REPORT) || null,
      items: items,
      supoCreatedDate: supoInvoice.createdOn,
      submittedToFinanceBridge: supoInvoice.submittedToFinanceBridge
    });
  }
}
